module.exports = __webpack_public_path__ + "img/recharge_level_disable.ed2827c8.png";